import { all, put, takeEvery, select } from 'redux-saga/effects'
import _ from 'lodash'

import { getCustomData } from '@global/selectors'

import config from '../../../../../../../../../config'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import { blockSaveCustomData } from '../../../../../../../components/Workspace/components/HocBlock/actions'

import { TOGGLE_ROLE_SECTION, PIN_PARTICIPATION_ELEMENT, ROLES_SET_CLICKED_ELEMENT } from '../../Role/constants'

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.rolesInCompanies.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    // Custom data for block
    yield put(blockSaveCustomData(module, id, blockKey, { openSections: {}, pinnedIndex: null, clickedElement: {} }))

    return null
}

function* rolesInCompaniesChangeCustomData(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.rolesInCompanies.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = yield select(getCustomData, module, blockKey, id)
    const incomingChange = _.get(action, 'data.customData', null)

    yield put(blockSaveCustomData(module, id, blockKey, { ...customData, ...incomingChange }))

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, onDataLoaded),
        takeEvery(TOGGLE_ROLE_SECTION, rolesInCompaniesChangeCustomData),
        takeEvery(PIN_PARTICIPATION_ELEMENT, rolesInCompaniesChangeCustomData),
        takeEvery(ROLES_SET_CLICKED_ELEMENT, rolesInCompaniesChangeCustomData),
    ])
}
